import { Injectable } from '@angular/core';
import { ManagedRole, isManagedRole } from '../../domain/models/local-user-role.model';
import { Role } from '../../domain/models/role.model';
import { RoleOption } from '../../domain/models/role-option.model';
import { RoleDto } from '../dtos/role.dto';

@Injectable()
export class RoleMapper {
  public toManagedRoleOptions(dtos: readonly RoleDto[]): readonly RoleOption[] {
    return dtos
      .filter((dto): dto is RoleDto & { Name: ManagedRole } => isManagedRole(dto.Name))
      .map((dto) => ({ id: dto.Id, name: dto.Name }));
  }

  public toRole(dto: RoleDto): Role {
    return { id: dto.Id, name: dto.Name, permissions: dto.Permissions ?? [] };
  }
}
